export default __webpack_public_path__ + "static/media/aws-ec2.1241b36c.svg";